<template>
	<Select ref="sel"
	    v-bind="$attrs"
	    v-on="$listeners"
	    label-in-value
	    :multiple="false"
	    :value="value"
	    :class="prefixCls"
	    @input="onInput"
	    @on-clear="onClear"
	    @on-open-change="onOpenChange"
	    @on-option-click="onOptionClick"
	    @on-search="onSearch">
		<Option v-for="(item, index) in optionList"
		    v-show="querying"
		    :data-querying="querying"
		    :key="index"
		    :value="item[id]"
		    :label="item[text]">
		</Option>
		<Tree ref="tree"
		    v-show="!querying"
		    :data="treeData"
		    :render="optRender"
		    :itemClass="itemClass"
		    :container="dropEle"
		    @on-select-change="onSelect"></Tree>
	</Select>
</template>
<script>
import { listToTree, type } from '../../utils/assist'
import { Select, Option } from '../select'
import Field from '../../mixins/field';
import Tree from '../tree'
// 支持filter高级搜索组件
import Filterable from '../filter/filterable'

export default {
	name: "SelectTree",
	mixins: [Filterable, Field],
	inheritAttrs: false,
	composed: true,
	components: {
		Select,
		Option,
		Tree
	},

	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		list: {
			type: Array,
			default: () => []
		},
		id: {
			type: String,
			default: "id"
		},
		pId: {
			type: String,
			default: "pid"
		},
		text: {
			type: String,
			default: "name"
		},
		// 能否选中
		selectable: {
			type: Function
		},
		// 是否显示全路径名称
		fullPathName: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			treeData: [],
			treeMap: [],
			optionList: [],

			querying: false,
			clickedOption: null,
			focusIndex: -1,
			dropEle: void(0),
		}
	},

	computed: {
		prefixCls() {
			return "ivu-select-tree"
		},
		curText() {
			return this.getText(this.value)
		},
	},

	methods: {
		optRender(h, { root, node, data }) {
			var me = this,
				selectable = data.selectable

			return h("div", {
				on: {
					click() {
						// 重复选择
						if (me.value == data[me.id]) {
							return me.$refs.sel.hideMenu()
						}

						// 数据标识是否可选
						if (selectable || type(selectable) == "undefined") {
							me.$refs.tree.handleSelect(node.nodeKey)
						} else {
							me.$refs.tree.handleExpand(node.nodeKey)
						}
					}
				},
				style: {
					padding: "8px 0",
					lineHeight: "20px"
				},
			}, [
				h("span", {
					style: {
						padding: "0 4px"
					}
				}, data.__title__)
			])
		},

		// tree-option 样式
		itemClass({ data }) {
			var disabled = data.disabled,
				selectable = data.selectable,
				selected = this.value == data[this.id]

			return {
				[this.prefixCls + "-item"]: true,
				[this.prefixCls + "-item-selected"]: selected,
				[this.prefixCls + "-item-disabled"]: disabled,
			}
		},

		getText(id) {
			var opt = this.optionList.find(v => v[this.id] == id)

			return opt ? opt[this.text] : id
		},

		getFullPathName(id) {
			var node = this.treeMap[id],
				name = id

			if (node) {
				name = node[this.text]

				var parent = this.treeMap[node[this.pId]]
				while (parent) {
					name = parent[this.text] + '-' + name
					parent = this.treeMap[parent[this.pId]]
				}
			}

			return name
		},

		// select listener
		onInput(id) {
			if (id) {
				this.focusIndex = this.treeMap[id].nodeKey
			}else{
				this.focusIndex = -1
			}
		},

		onClear(){
			this.$nextTick(() => this.dispatchFormChange(''))
		},

		// tree listener
		onSelect(e) {
			var node = e[0],
				txt = this.getText(node.id)

			if (node) {
				this.$emit("input", node.id)
				this.$emit("on-change", {
					[this.id]: node[this.id],
					[this.text]: txt
				})
				this.dispatchFormChange(node.id)
				this.$refs.sel.hideMenu()
				this.focusIndex = node.nodeKey
			}
		},

		onOpenChange(state) {
			// console.log(state)
			if (state) {
				this.clickedOption = null
				this.$nextTick(() => this.$refs.tree.focusOn(this.focusIndex))
			} else {
				// 点击option结束搜索
				if (this.clickedOption) {
					// drop收起动画后再隐藏optionList
					setTimeout(() => this.querying = false, 300)
				}
			}
		},

		onSearch(query) {
			// 开启搜索交互
			this.querying = true
		},

		onOptionClick(option) {
			this.clickedOption = option
		}
	},

	mounted() {
		this.$nextTick(() => {
			this.dropEle = this.$refs.sel.$refs.dropdown.$el
		})
	},

	watch: {
		list: {
			handler(val) {
				// 树形化
				listToTree(val, {
					id: this.id,
					pId: this.pId,
					done: (tree, map, list) => {
						// tree data
						this.treeMap = map
						this.treeData = tree

						// normalize
						list.forEach(v => {
							// 是否可选
							var selectable = v.selectable

							if (type(v.selectable) == "undefined") {
								selectable = this.selectable
							}

							if (type(selectable) == "function") {
								selectable = selectable({ root: tree, node: v, data: v })
							}

							v.selectable = selectable

							// 默认都可选
							if (type(v.selectable) == "undefined") {
								v.selectable = true
							}

							// 是否显示全路径名称
							if (this.fullPathName) {
								v[this.text] = this.getFullPathName(v[this.id])
							}

							// 树节点文本
							v.__title__ = v[this.text]
						})

						// select options
						this.optionList = list.filter(v => v.selectable)
					}
				})
			},
			immediate: true
		}
	}
}
</script>